import React from "react"
import { useTranslation } from "react-i18next"

import { DataGridToolbar } from "@/nzds/data-grid"
import { useDownloadBillsExport } from "@/services/bill/use-download-bills-export"

import { MenuItem } from "@mui/material"
import type { GridSlots, PropsFromSlot } from "@mui/x-data-grid-pro"

interface SiteBillsGridToolbarProps extends PropsFromSlot<
  GridSlots["toolbar"]
> {
  canDownload: boolean
  downloadHref?: string
  excelDownloadHref?: string
  isRecordCountLoading?: boolean
  recordCount?: number
}

const startBillsExport = (
  exportFile: (href: string) => void,
  href: string | undefined
): void => {
  if (!href) {
    return
  }

  exportFile(href)
}

export const SiteBillsGridToolbar: React.FC<SiteBillsGridToolbarProps> = ({
  canDownload,
  downloadHref,
  excelDownloadHref,
  isRecordCountLoading,
  recordCount,
}) => {
  const { t } = useTranslation("common")
  const { billsExportIsPending, billsExportMutate } = useDownloadBillsExport()
  const isExportDisabled = !canDownload || billsExportIsPending

  return (
    <DataGridToolbar
      isMoreMenuDisabled={!canDownload}
      isMoreMenuLoading={billsExportIsPending}
      isRecordCountLoading={isRecordCountLoading}
      moreMenuItems={
        <>
          <MenuItem
            component="button"
            disabled={isExportDisabled}
            onClick={() => {
              startBillsExport(billsExportMutate, downloadHref)
            }}
          >
            {t("menuItem.exportCsv")}
          </MenuItem>
          <MenuItem
            component="button"
            disabled={isExportDisabled}
            onClick={() => {
              startBillsExport(billsExportMutate, excelDownloadHref)
            }}
          >
            {t("menuItem.exportExcel")}
          </MenuItem>
        </>
      }
      recordCount={recordCount}
    />
  )
}
